import { API_BASE_URL, LOGIN_ENDPOINT } from "../../utils/API_CONSTANTS";

class APIError extends Error {
  constructor(message, statusCode) {
    super(message);
    this.name = "APIError";
    this.statusCode = statusCode;
  }
}

const LoginUser = async (rollNo, password) => {
  try {
    const response = await fetch(`${API_BASE_URL}${LOGIN_ENDPOINT}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        rollNo: rollNo,
        password: password,
        reg_token: rollNo, // Ensure this is correct and intended
      }),
    });

    // Check if the response is ok (status in the range 200-299)
    if (!response.ok) {
      const errorData = await response.json();
      throw new APIError(errorData.message || "An error occurred during login.", response.status);
    }

    // Access the response data
    const data = await response.json();

    return {
      message: data.message,
      statusCode: response.status,
      token: data.token
    };
  } catch (error) {
    // Handle network errors or other exceptions
    const errorMessage = error instanceof APIError
      ? error.message
      : error.message || "An unknown error occurred.";

    throw new APIError(errorMessage, error.statusCode || 500);
  }
};

export default LoginUser;
